import { Http } from "@angular/http";
import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";

@Injectable()
export class EbsWebServiceGlobals {

  private _baseURL: string = "";
  private _colorDesign: string = "red";
  private _iframeURL: string = "";
  private _loginUrl: string = "";
  private _ebsWebServiceEntryURL = "";
  private _ebsWebServiceSearchURL = this._baseURL + "SearchAsJSON";
  private _ebsWebServiceSearchURLParams = "userKey=" + this.getUserHash() + "&path=&district=&param1=&param2=&param3=&param4=&param5=&searchWord=";
  private _ebsWebServiceMainNavigationURL = "";
  public _ebsWebServiceMainContentURL = "";
  private _projectIdentifier = "";

  private _showLoginScreen: boolean = false;
  private _debugMessage: string = "";
  private _showDebugMessage: boolean = false;
  private _debugUrl: string = "";
  private _username: string = "";
  private _usericon: string = "";
  private _debugPostParams: object;
  private _betaVersion = true;
  private _showGeneralSearch = true;
  private _reloadMenu = false;
  private _alternativeHomeScreen = "";
  private _loadIconsFromStorage = false;
  private _http2redirect = "";

  constructor(private http: Http, public events: Events) {
    this.loadConfigFile();
  }

  setBaseURL(baseURL) {
    this._baseURL = baseURL;
    this._ebsWebServiceMainNavigationURL = baseURL + "GetMainNavigationAsJSON";
    this._ebsWebServiceEntryURL = baseURL + "GetAsJSON";
    this._ebsWebServiceMainContentURL = baseURL + "GetMainContentAsJSON";
    this._ebsWebServiceSearchURL = baseURL + "SearchAsJSON";
  }

  getBaseURL() {
    return this._baseURL;
  }

  loadConfigFile() {
    // path für android build
    //this.http.get('/android_asset/www/assets/ebs_configuration.json').map(res => res.json()).subscribe(data => {
    let pathname = window.location.pathname; // current path
    if (pathname.endsWith('.html')) {
      pathname = pathname.split('/').slice(0, -1).join('/'); // if path to file like index.html remove index.html
    }
    if(!pathname.endsWith('/')) {
      pathname = pathname + '/'; // path should end with /
    }
    console.log(`Loading Config File [url]=[${pathname + 'assets/ebs_configuration.json'}]`);
    this.http.get(pathname + 'assets/ebs_configuration.json').map(res => res.json()).subscribe(data => {
      if (data.externalPath != "") {
        this.http.get(data.externalPath).map(res => res.json()).subscribe(data => {
          this.configApp(data);
        });
      } else {
        this.configApp(data);
      }
    });
  }

  configApp(data) {
    this.setBaseURL(data.baseURL);
    this.setBetaVersion(data.betaVersion);
    this.setColorDesign(data.colorDesign);
    this.setShowGeneralSearch(data.showGeneralSearch);
    this.setReloadMenu(data.reloadMenu);
    this.setAlternativeHomeScreen(data.alternativeHomeScreen);
    this.setProjectIdentifier(data.projectIdentifier);
    this.setLoadIconsFromStorage(data.loadIconsFromStorage);
    this.setHttp2Redirect(data.http2redirect);
    document.getElementsByName('apple-mobile-web-app-title')[0].setAttribute('content', data.mobileWebAppTitle || 'EBS-App');
    this.events.publish('setting:ConfigFileLoaded');
  }

  setHttp2Redirect(http2redirect) {
    this._http2redirect = http2redirect;
  }

  getHttp2Redirect() {
    return this._http2redirect;
  }

  setLoadIconsFromStorage(loadIconsFromStorage) {
    console.log('Set load icons from storage', loadIconsFromStorage);
    this._loadIconsFromStorage = loadIconsFromStorage;
  }

  getLoadIconsFromStorage() {
    return this._loadIconsFromStorage;
  }

  setBetaVersion(versionFlag) {
    this._betaVersion = versionFlag;
  }

  getBetaVersion() {
    return this._betaVersion;
  }

  setProjectIdentifier(projectIdentifier) {
    this._projectIdentifier = projectIdentifier;
  }

  getProjectIdentifier() {
    return this._projectIdentifier;
  }

  getEbsWebServiceMainNavigationURL() {
    return this._ebsWebServiceMainNavigationURL;
  }

  getEBSWebServiceMainContentURL() {
    return this._ebsWebServiceMainContentURL;
  }

  getEbsWebServiceEntryURL() {

    return this._ebsWebServiceEntryURL;
  }

  getEbsWebServiceSearchURL() {

    return this._ebsWebServiceSearchURL;
  }

  setEbsWebServiceSearchURL(ebsWebServiceSearchURL) {
    this._ebsWebServiceSearchURL = ebsWebServiceSearchURL;
  }

  getEbsWebServiceSearchURLParams() {
    return this._ebsWebServiceSearchURLParams;
  }

  setEbsWebServiceSearchURLParams(ebsWebServiceSearchURLParams) {
    this._ebsWebServiceSearchURLParams = ebsWebServiceSearchURLParams;
  }

  getShowLoginScreen() {
    return this._showLoginScreen;
  }

  setShowLoginScreen(showLoginScreen) {
    this._showLoginScreen = showLoginScreen;
  }

  setUserHash(userhash) {
    sessionStorage.setItem("userKey", userhash);
  }

  getUserHash() {
    return sessionStorage.getItem("userKey");
  }

  getIframeURL() {
    return this._iframeURL;
  }

  getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  setUsername(Name) {
    this._username = Name;
  }

  getUsername() {
    return this._username;
  }

  setUsericon(Icon) {
    this._usericon = Icon;
  }

  getUsericon() {
    return this._usericon;
  }

  setDebugMessage(debugMessage) {
    this._debugMessage = debugMessage;
  }

  getDebugMessage() {
    return this._debugMessage;
  }

  setShowDebugMessage(showDebugMessage) {
    this._showDebugMessage = showDebugMessage;
  }

  getShowDebugMessage() {
    return this._showDebugMessage;
  }

  setDebugUrl(debugUrl) {
    this._debugUrl = debugUrl;
  }

  getDebugUrl() {
    return this._debugUrl;
  }

  setDebugPostParams(debugPostParams) {
    this._debugPostParams = debugPostParams;
  }

  getDebugPostParams() {
    return this._debugPostParams;
  }

  setLoginUrl(loginUrl) {
    this._loginUrl = loginUrl;
  }

  getLoginUrl() {
    return this._loginUrl;
  }

  getColorDesign() {
    return this._colorDesign;
  }

  setColorDesign(colorDesign) {
    this._colorDesign = colorDesign;
  }

  getShowGeneralSearch() {
    return this._showGeneralSearch;
  }

  setShowGeneralSearch(showGeneralSearch) {
    this._showGeneralSearch = showGeneralSearch;
  }

  getReloadMenu() {
    return this._reloadMenu;
  }

  setReloadMenu(reloadMenu) {
    this._reloadMenu = reloadMenu;
  }

  setAlternativeHomeScreen(alternativeHomeScreen) {
    this._alternativeHomeScreen = alternativeHomeScreen;
  }

  getAlternativeHomeScreen() {
    return this._alternativeHomeScreen;
  }
}



// WEBPACK FOOTER //
// ./src/services/ebsWebServiceGlobals.ts